import React from "react";
import CustomICTooltip from "../Utility/Helpers/CustomICToolTip";
import { NOFOUrlGenerator } from "../Utility/Helpers/sitewide";
import { Parser } from "html-to-react";

function MobileDataView({ data, fullName, date_utc_options }) {
  return (
    <>
      {data.map((foa) => {
        return (
          <div className="col-12 mb-4">
            <div className="card-header bg-primary">
              <div className="px-4 py-3 text-white">
                <div className="">Notice Number</div>
                <div>
                  <a
                    className="link-white"
                    href={foa._source.ggid ? "https://simpler.grants.gov/opportunity/"+foa._source.ggid : NOFOUrlGenerator(foa._source.filename)}
                  >
                    {foa._source.docnum}
                  </a>
                </div>
              </div>
            </div>
            <div className="card-content bg-white px-4 py-2">
              <div className="mt-3"></div>
              <div className="fw-bold">Title</div>
              <p>
                {foa.highlight && foa.highlight.title
                  ? Parser().parse(foa.highlight.title.join())
                  : foa._source.title}
              </p>
              <hr />
              <div className="fw-bold">Issuing Organization</div>
              <p>
                <CustomICTooltip
                  ic={foa._source.primaryIC}
                  name={fullName(foa._source.primaryIC)}
                />
              </p>
              <hr />
              <div className="fw-bold">Participating Organization(s)</div>
              <p>
                {" "}
                {foa._source.sponsors &&
                foa._source.sponsors.length > 0 &&
                foa._source.sponsors[0] !== "none"
                  ? foa._source.sponsors.map((spons, index) => {
                      return index === foa._source.sponsors.length - 1 ? (
                        <CustomICTooltip ic={spons} name={fullName(spons)} />
                      ) : (
                        <>
                          <CustomICTooltip ic={spons} name={fullName(spons)} />,{" "}
                        </>
                      );
                    })
                  : "N/A"}
              </p>
              <hr />
              <div className="fw-bold">Activity Code</div>
              <p>
                {" "}
                {foa._source.ac
                  ? foa._source.ac.map((ac, index) => {
                      return index === foa._source.ac.length - 1 ? (
                        <span>{ac}</span>
                      ) : (
                        <span>{ac}, </span>
                      );
                    })
                  : "N/A"}
              </p>
              <hr />
              <div className="fw-bold">Release Date</div>
              <p>
                {" "}
                {foa._source.reldate
                  ? new Intl.DateTimeFormat("en-US", date_utc_options).format(
                      new Date(foa._source.reldate)
                    )
                  : "N/A"}
              </p>
              <hr />
              <div className="fw-bold">Expiration Date</div>
              <p>
                {" "}
                {foa._source.expdate
                  ? new Intl.DateTimeFormat("en-US", date_utc_options).format(
                      new Date(foa._source.expdate)
                    )
                  : "N/A"}
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default MobileDataView;
